module.exports = __webpack_public_path__ + "static/media/female.19033111.jpg";